import React, { useEffect, useRef, useState } from "react";
import { components } from 'react-select';
import { ViewSelect } from "./view-select";
import SwitchButton from "./switch-button";
import { CalendarViewIcon } from "../../../assets/icons/calender-view-icon";
import { CalendarSelectedViewIcon } from "../../../assets/icons/calender-view-selected-icons";
import { CalendarWeekIcon } from "../../../assets/icons/calender-week-icon";
import { CalendarSelectedWeekIcon } from "../../../assets/icons/calender-week-selected-icons";
import { AgendaIcon } from "../../../assets/icons/agenda-icon";
import { AgendaSelectedIcon } from "../../../assets/icons/agenda-selected-icon";
import { DaySelectedIcon } from "../../../assets/icons/day-selected-icon";
import { DayIcon } from "../../../assets/icons/day-icon";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarFilterIconButton from "../../common/buttons/calendar-filter-icon-buttons";


const CalendarHeader = ({ currentDate, setCurrentDate, view, setView, showDatePicker, setShowDatePicker, onSelect, setIsAgendaOpen, isRecruiterOpen, setIsRecruiterOpen, setSelectedEvent }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const dropdownRefCal = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRefCal.current && !dropdownRefCal.current.contains(event.target)) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);



  const viewOptions = [
    {
      value: "Day", label: "Day", icon: <DayIcon />, selectedIcon: <DaySelectedIcon />
    },
    {
      value: "Work Week", label: "Work Week", icon: <CalendarWeekIcon />, selectedIcon: <CalendarSelectedWeekIcon />
    },
    {
      value: "Week", label: "Week", icon: <CalendarViewIcon />, selectedIcon: <CalendarSelectedViewIcon />
    },
    {
      value: "Agenda", label: "Agenda", icon: <AgendaIcon />, selectedIcon: <AgendaSelectedIcon />
    }
  ];



  const DropdownIndicator = (
    props
  ) => {
    return (
      <components.DropdownIndicator {...props}>
        <span class=" pointer-events-none">
          <svg className="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path></svg>
        </span>
      </components.DropdownIndicator>
    );
  };

  const CustomSingleValue = ({ data }) => (
    <div className="flex items-center gap-2">
      {data.icon} {data.label}
    </div>
  );

  // Define the styles and behavior for the select box
  const customComponents = {
    SingleValue: CustomSingleValue,
    DropdownIndicator,
    IndicatorSeparator: () => null,
  };

  return (
    <>
      <div className="flex justify-between items-center rounded-lg px-4 pt-4 mb-4">
        <div className="flex items-center space-x-4">
          <SwitchButton onSelect={onSelect} />
          <button onClick={() => setCurrentDate(new Date())} className=" text-[#1B2A3D] px-4 py-2 rounded-lg font-[500] underline">Today</button>
          <div className="flex items-center space-x-5">

            <button
              onClick={() => {
                setCurrentDate((prev) => {
                  const newDate = new Date(prev);
                  const delta = view === "Day" ? 1 : view === "Work Week" ? 5 : 7;
                  newDate.setDate(newDate.getDate() - delta);
                  return newDate;
                });
              }}
            >
              <svg className="p-[1px]" xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 16" fill="none">
                <path d="M8.5 1L1.5 8L8.5 15" stroke="#245CEA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button
              onClick={() => {
                setCurrentDate((prev) => {
                  const newDate = new Date(prev);
                  const delta = view === "Day" ? 1 : view === "Work Week" ? 5 : 7;
                  newDate.setDate(newDate.getDate() + delta);
                  return newDate;
                });
              }}
            >
              <svg className="p-[1px]" xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 16" fill="none">
                <path d="M1.5 15L8.5 8L1.5 1" stroke="#245CEA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
          <div ref={dropdownRefCal}>
            <button onClick={() => setShowDatePicker(!showDatePicker)} className="flex items-center space-x-1 bg-white px-3 py-2 rounded-lg font-semibold">
              <span>{currentDate.toLocaleString('default', { month: 'long', year: 'numeric' })}</span>

              <span class="relative right-[-5px] top-[12px] transform -translate-y-1/2 pointer-events-none"><svg width="18" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>
            </button>
            {showDatePicker && (
              <div className="absolute z-50 bg-white shadow-lg rounded-lg p-2 top-14 left-[30%] transform -translate-x-1/2">
                <DatePicker selected={currentDate} onChange={setCurrentDate} inline />
              </div>
            )}
          </div>
        </div>


        <div className="flex items-center space-x-4" ref={dropdownRef}>
          <ViewSelect selected={view} setSelected={setView} viewOptions={viewOptions} setIsAgendaOpen={setIsAgendaOpen} isOpen={isOpen} setIsOpen={setIsOpen} setSelectedEvent={setSelectedEvent} />
          <CalendarFilterIconButton onClick={() => { setIsRecruiterOpen(true) }} />
        </div>
      </div>
    </>
  );
};

export default CalendarHeader;